export default "__VITE_ASSET__DBj2DOVw__"